import React from 'react'
import { FormattedMessage } from 'react-intl'

import { ButtonColor } from '../../../ui-lib/button'
import { SignUpProductRecButton } from '../../../item/cta-button/signup-product-recommendation'
import { OutputDetectedShape, OutputTitle, OutputAiDetected } from '../output-components'

import styles from './ai-detector-desktop.module.scss'

interface AIDetectorDesktopOutputProps {
  aiPercent: number | null
}

export const AIDetectorDesktopOutput: React.FC<AIDetectorDesktopOutputProps> = (props) => {
  const { aiPercent } = props
  const hasAiPercent = aiPercent !== null

  return (
    <div className={styles.outputContainer}>
      <div className={styles.outputAIContent}>
        <OutputDetectedShape />
        <OutputTitle aiPercent={aiPercent} />
      </div>
      <OutputAiDetected aiPercent={aiPercent} />
      <div className={styles.outputButtonContainer}>
        <SignUpProductRecButton
          compact
          color={ButtonColor.WDK24SecondaryLightBg}
          text={
            hasAiPercent && aiPercent > 0 ? (
              <span>
                <strong>
                  <FormattedMessage
                    id="phrase.getGrammarly"
                    description="Get Grammarly"
                    defaultMessage="Get Grammarly"
                  />
                </strong>
              </span>
            ) : (
              <span>
                <strong>
                  <FormattedMessage
                    id="phrase.getGrammarly"
                    description="Get Grammarly"
                    defaultMessage="Get Grammarly"
                  />
                </strong>
                &nbsp;
                <FormattedMessage
                  id="phrase.itsFree"
                  description="Sign up prompt value prop"
                  defaultMessage="It's free"
                />
              </span>
            )
          }
          showArrow
        />
      </div>
    </div>
  )
}
